export enum CUSTOMER_PROPERTY_NAME {
    POPUP_ID = 'popup_id',
    POPUP_NAME = 'popup_name'
}
